import { useState, useEffect, useCallback } from "react";
import { getSpendingBreakdownDonuts } from "../../api/finances/spendingsAPI";

const createInitialBreakdownData = () => ({
  breakdown: {
    All: {
      categories: [],
      accounts: [],
    },
  },
});

export function useSpendingBreakdown() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [spendingBreakdown, setSpendingBreakdown] = useState(
    createInitialBreakdownData(),
  );

  const loadSpendingBreakdown = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const data = await getSpendingBreakdownDonuts();
      setSpendingBreakdown(data);
    } catch (err) {
      setSpendingBreakdown(createInitialBreakdownData());
      setError("We could not load your spending breakdown. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSpendingBreakdown();
  }, [loadSpendingBreakdown]);

  return {
    isLoading,
    error,
    spendingBreakdown,
    breakdown: spendingBreakdown.breakdown,
    refresh: loadSpendingBreakdown,
  };
}
